import React, { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import NewLocationPicker from '../map screens/NewLocationPicker';

const NewLocationDialog = ({
  open,
  onClose,
  setLatLangVal,
  updateLocationFormData,
  setMobileBackColor,
  setMobileTextColor,
  setMobileCardBorderColor,
  openLocationFormDailog,
  closeLocationFormDailog,
  closeMapModal
}) => {

  return (
    <Dialog
      className="alignByLang"
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent className="alignByLang" sx={{
        backgroundColor: setMobileBackColor(),
        color: setMobileTextColor(),
        border: `1px solid ${setMobileCardBorderColor()}`
      }}>

        <NewLocationPicker
          openLocationFormDailog={openLocationFormDailog}
          closeLocationFormDailog={closeLocationFormDailog}
          latlangVal={setLatLangVal}
          closeMapModal={closeMapModal}
          updateLocationFormData={updateLocationFormData}
          is_from_update={false}
          latitude={false}
          longitude={false}
        />
      </DialogContent>
    </Dialog>
  );
};

export default NewLocationDialog;